<div class="catalog-header">
    <div class="catalog-breadcrumb">
        <breadcrumb></breadcrumb>
    </div>
    <div class="social-share">
        <div class="float-end">
            <facebook-button
                *ngIf="displayFbCatalogShareables"
                class="share-list-facebook-button"
                [shareOptions]="shareOptions"
                aria-label="Share on Facebook"></facebook-button>
            <copy-short-url
                *ngIf="displayUrlCatalogShareables"
                class="share-list-url"
                buttonClass="btn-primary"
                [shareOptions]="shareOptions"
                aria-label="Copy short URL"></copy-short-url>
        </div>
    </div>
</div>

